import React from 'react'
import Header from '../Component/Header'
import { Link } from 'react-router-dom'
import Footer from'../Component/Footer' 
import { useEffect, useState } from 'react'; 
import {getFaculty} from'../Service/Api'
import LazyLoad from 'react-lazyload';
const EchosofWisdom = () => {
  useEffect(() => {
    // Set the page title
    document.title = 'Echos of Wisdom - Presentation Convent School Delhi';  
  }, []);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); 
  console.log(data);

  useEffect(() => {
      const fetchData = async () => {
          try {
              const CatalystofGrowth = await getFaculty();
              const CatalystData = CatalystofGrowth.filter(item => item.category === "Wisdom")
              const sortedData = CatalystData.sort((a, b) => a.name.localeCompare(b.name));
              setData(sortedData);
              
          } catch (error) {
              console.log("Data Error", error);
          } finally{
              setLoading(false)
          }
      };
      fetchData();
  }, []);
  const emptyData = [
     { id: 1},
     { id: 2},
     { id: 3}
 ];
  return (
     <>
       <Header/>
        <div className="innerslide"> 
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li> School </li>
                <li>Echos of Wisdom</li>
            </ul>
       </div>
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Echoes of Wisdom : A Century Shaped </h1>
                    </div>
                </div>
                <div className="row">
                {data.length > 0 ? data.map((item,index) => (
                  <div className="col-xxl-3 col-lg-4 col-md-4" key={index}>
              <div className="management">
                {item.attachments.length>0 ? (<img src={`https://webapi.entab.info/api/image/${item.attachments}`} className="img-fluid" alt=""/> ) : 
                (<img alt="PCS DELHI" src="https://webapi.entab.info/api/image/PCSD/public/Images/defaultImage.jpg" className="img-fluid"/>)
              }
              
                <div className="management-detils">
                  <h4> {item.name} </h4>
                  <h5> {item.year} </h5>
                </div>
              </div>
            </div>  
            )) : emptyData.map((data) => (
                 <div className="col-xxl-3 col-lg-4 col-md-4" key={data.id}>
              <div className="management">
              <LazyLoad>  <img alt="PCS DELHI" src="https://webapi.entab.info/api/image/PCSD/public/Images/defaultImage.jpg" className="img-fluid"/></LazyLoad>
                <div className="management-detils">
                  <h4> Name </h4>
                  <h5> YY -YY  </h5>
                </div>
              </div>
            </div>   
                ))}
              </div>
            </div>  
        </div> 
       <Footer/>
     </>
  )
}

export default EchosofWisdom
